<div
  id="multi-select-wrapper"
  class="multi-select-wrapper"
  [ngClass]="getClassName()"
>
  <mat-select
    id="multi-select"
    [placeholder]="'multiSelect.default' | translate"
    #select
    multiple
    (openedChange)="closeOptions($event)"
    panelClass="multi-select"
    [(ngModel)]="selectedItemList"
  >
    <mat-select-trigger id="multi-select-trigger">
      {{ getSelectedCount() }}
    </mat-select-trigger>
    <div id="multi-select-options" class="multi-select-options">
      <mat-option
        [id]="'mat-select-option-' + index"
        (click)="checkIsAllSelected()"
        *ngFor="let option of data; let index = index"
        [value]="option.value"
      >
        <app-text id="shared-checkbox-text-data" [textStyleType]="'body1'">
          {{ option.name }}</app-text
        >
      </mat-option>
    </div>
    <div id="multi-select-buttons" class="multi-select-buttons">
      <app-button
        id="multi-select-all-btn"
        class="multi-select-all-btn"
        [text]="getSelectText() | translate"
        [buttonType]="'textLink'"
        [isTextLinkBtn]="'true'"
        [btnPadding]="'0.75em 1.2em'"
        (buttonClick)="toggleAllSelection()"
      >
      </app-button>
      <app-button
        class="multi-select-apply-btn"
        id="multi-select-apply-btn"
        [text]="'multiSelect.apply' | translate"
        [buttonType]="'secondary'"
        (buttonClick)="applyClicked()"
      >
      </app-button>
    </div>
  </mat-select>
</div>
